var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48pt",
    height: "48pt",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941176%,92.941176%,95.294118%)",
      fillOpacity: 1
    },
    d: "M 33.5 12.101562 C 33.5 6.601562 29.5 3.601562 23.5 3.601562 C 18.398438 3.601562 14.199219 6 12.800781 10.601562 L 9.800781 9 C 11.800781 3.199219 17.398438 0.300781 23.5 0.300781 C 30.898438 0.300781 37 4.398438 37 12.101562 C 37 22 24.300781 25.101562 24.300781 35.101562 L 20.800781 35.101562 C 20.800781 23.601562 33.5 20.898438 33.5 12.101562 Z M 19.601562 44.699219 C 19.601562 43.101562 20.800781 41.699219 22.601562 41.699219 C 24.199219 41.699219 25.601562 43 25.601562 44.699219 C 25.601562 46.300781 24.300781 47.699219 22.601562 47.699219 C 20.898438 47.601562 19.601562 46.300781 19.601562 44.699219 Z M 19.601562 44.699219 "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.57b022ecda558d9eb69f7f2b26be0870.svg";
export { ForwardRef as ReactComponent };